import { render, staticRenderFns } from "./DefaultPopup.vue?vue&type=template&id=3037ac56&scoped=true&"
import script from "./DefaultPopup.vue?vue&type=script&lang=js&"
export * from "./DefaultPopup.vue?vue&type=script&lang=js&"
import style0 from "./DefaultPopup.vue?vue&type=style&index=0&id=3037ac56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3037ac56",
  null
  
)

export default component.exports